export const boardAutomationTour = {
  key: "boardAutomation",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-automation-add"]',
      content: t("Tour_BoardAutomation_Add"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-automation-rules"]',
      content: t("Tour_BoardAutomation_Rules"),
      placement: "center",
    },
  ],
};
